module.exports = __webpack_public_path__ + "static/media/expget.16985224.mp3";